// extracted by mini-css-extract-plugin
module.exports = {"hero":"home_hero__Nj50H","categoriesBox":"home_categoriesBox__15_6W"};